import { Box, Grid, Typography, useTheme } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, validateYupSchema, yupToFormErrors } from '../../lib/formik/Formik';
import MFSelectField from '../../lib/formik/SelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import { Applicant } from '../../redux-store/types/api-types';
import {
  addressTypesMasters,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  USER_ROLES,
} from '../../utils/constant';
import {
  applicationComparison,
  applyRoleBasedStatus,
  getApplicantName,
  isModuleAllowed,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useRouteMatch } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { FATCAValidationSchema } from '../../utils/schema';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { GetUboIdentificationTypeListResponse, mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList, getUboIdentificationTypeList } from '../../redux-store/actions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import React from 'react';

export type Values = {
  applicants: Partial<Applicant>[];
  saveType: string;
  countryDropdown: string[];
};

const initialValues: Values = {
  applicants: [
    {
      typeOfAddressProvidedAtKRA: '',
      taxResidentOfAnyCountryOtherThanIndia: false,
      placeOfBirth: '',
      countryOfBirth: 'INDIA',
      countryOfNationality: 'INDIA',
      taxCountryName: '',
      taxID: '',
      idType: '',
      nameOfEntity: '',
      dateOfIncorporation: '',
      cityOfIncorporation: '',
      countryOfIncorporation: '',
      entityExcemptionCode: '',
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
};

const FatcaDetails = ({
  applicantName,
  index,
  values,
  nationalitiesMdmsResponse,
  fatcaIdTypeList
}: {
  applicantName: string;
  index: number;
  values: Partial<Applicant>;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  fatcaIdTypeList: Array<string>;
}): JSX.Element => {
  const { path: currentPath } = useRouteMatch();
  const theme = useTheme();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")
  const isFieldDisabled = isDiyInvestorOnboarding ? false : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);

  const isNRI = `${values?.applicantStatus ?? ""}`.toLowerCase() === 'nri';

  return (
    <>
      {/* <SubHeading>FATCA Details of {applicantName} Applicant</SubHeading> */}
      <Grid item xs={12}>
        <SubHeading sx={{ marginTop: '26px' }}>
          <Typography
            sx={{
              color: `${theme.palette.text.primary}`,
              fontSize: "16px",
              fontFamily: `${theme.typography.fontFamily}`,
              letterSpacing: '0.2px',

            }}>
            FATCA Details of {applicantName} Applicant
          </Typography>
        </SubHeading>
      </Grid>

      {/* <Grid container> */}
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.typeOfAddressProvidedAtKRA`}
          label="Type of Address Provided At KRA *"
          items={addressTypesMasters.map((address) => ({ key: address, value: address }))}
        />
      </Grid>
      <Grid item xs={12} lg={6} />
      {/* </Grid> */}

      <Grid item xs={12} lg={4}>
        {/* <Grid item xs={12} lg={6} sx={{ pt: '25px !important' }}> */}
        <UseRadioGroup
          formLabel="Tax Resident of any country other than India *"
          labelColor={theme.palette.text.secondary}
          name={`applicants.${index}.taxResidentOfAnyCountryOtherThanIndia`}
          items={[
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
          ]}
          value={values.taxResidentOfAnyCountryOtherThanIndia?.toString()}
          disabled={isFieldDisabled || isNRI}
        />
        {/* </Grid> */}
      </Grid>
      <Grid item lg={8} sx={{ display: { xs: 'none', lg: 'block' } }} />
      {/* {applicant?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && ( */}
      <>
        <Grid item xs={12} lg={6}>
          <MFTextField
            name={`applicants.${index}.placeOfBirth`}
            label="Place of Birth *"
            placeholder="Enter Place of Birth"
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            placeholder="Enter Country of Birth"
            disabled={isFieldDisabled}
          /> */}
          {/* <SearchableSelect
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          /> */}
          {/* <MFSelectField
            name={`applicants.${index}.countryOfBirth`}
            label={'Country Of Birth *'}
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            isCapitalize
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfBirth`}
            label={'Country Of Birth *'}
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            placeholder="Enter Country of Nationality"
            disabled={isFieldDisabled}
          /> */}
          {/* <SearchableSelect
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          /> */}
          {/* <MFSelectField
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            isCapitalize
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          />
        </Grid>
        {values?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && (
          <>
            <Grid item xs={12} lg={6}>
              <SearchableSelect
                name={`applicants.${index}.taxCountryName`}
                label="Tax country Name *"
                items={nationalitiesMdmsResponse.map((nationality) => ({
                  key: nationality.name,
                  value: nationality.name,
                }))}
                disabled={isFieldDisabled}
                searchFieldPlaceholder={'Search Country'}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <MFTextField
                name={`applicants.${index}.taxID`}
                label="Tax ID *"
                placeholder="Enter Tax ID"
                disabled={isFieldDisabled}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <MFSelectField
                name={`applicants.${index}.idType`}
                label="ID Type *"
                disabled={isFieldDisabled}
                items={(fatcaIdTypeList ?? []).map((idType) => ({ key: idType, value: idType }))}
                dropdownOptionStyle={{ whiteSpace: 'break-spaces' }}
              />
            </Grid>
          </>
        )}
        {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.nameOfEntity`}
              label="Name of Entity"
              placeholder="Enter Name of Entity"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Date of Incorporation"
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              maxDate={minDateForContributor()}
              name={`applicants.${index}.dateOfIncorporation`}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              value={applicant.dateOfBirth || minDateForContributor().toString()}
              onChange={(newValue) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant, ind) => {
                    if (index === ind) {
                      return {
                        ...applicant,
                        dateOfIncorporation: newValue?.toString(),
                      };
                    }
                    return applicant;
                  }),
                });
              }}
              textFieldStyles={{
                'label + &': {
                  mt: 4,
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #DDEAF3',
                },
                '& .MuiOutlinedInput-root': {
                  position: 'relative',
                  backgroundColor: 'common.white',
                  border: '1px solid #DDEAF3',
                  fontSize: 16,
                  '&:hover': {
                    borderColor: 'primary.main',
                    '.MuiOutlinedInput-notchedOutline': {
                      border: 0,
                    },
                  },
                  '.MuiOutlinedInput-notchedOutline': {
                    border: 0,
                  },
                  '.MuiInputBase-input': {
                    p: '10px 12px',
                  },
                  '&:focus-visible': {
                    outline: 'none',
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.cityOfIncorporation`}
              label="City of Incorporation"
              placeholder="Enter City of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.countryOfIncorporation`}
              label="Country of Incorporation"
              placeholder="Enter Country of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.entityExcemptionCode`}
              label="Entity Exemption Code"
              placeholder="Enter Entity Exemption Code"
            />
          </Grid> */}
      </>
      {/* )} */}
    </>
  );
};

export default function Fatca(): JSX.Element {
  const { path: currentPath } = useRouteMatch();

  const [fatcaDetails, setFatcaDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [fatcaIdTypeList, setFatcaIdTypeList] = useState<Array<string>>([])

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  const fetchNationalitiesList = async () => {
    const response = (await dispatch(
      getNationalityList()
    )) as unknown as nationaliyType;

    setMdmsCountriesList(response?.countries ?? []);

    return response
  }

  const fetchFatcaIdTypeList = async () => {
    const response = (await dispatch(
      getUboIdentificationTypeList()
    )) as unknown as GetUboIdentificationTypeListResponse;

    setFatcaIdTypeList(response?.fatca_id_type ?? []);

    return response
  }

  useEffect(() => {
    const { applicants = [] } = application || {};
    (async function () {
      try {

        const [nationalitiesListResult] = await Promise.allSettled([
          fetchNationalitiesList(),
          fetchFatcaIdTypeList()
        ])

        const nationalitiesList =
          nationalitiesListResult.status === 'fulfilled' ? nationalitiesListResult.value : {} as nationaliyType;

        setFatcaDetails({
          ...fatcaDetails,
          applicants: applicants?.map((applicant) => {

            const isNRI = `${applicant?.applicantStatus ?? ""}`.toLowerCase() === 'nri';

            return {
              typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
              // Business rule: an NRI applicant is always treated as a tax resident of
              // another country. When the stored value is falsy we seed it to `true` here
              // (and the radio is rendered disabled so the user cannot change it).
              // This is the single source of truth that seeds the Formik form state, which
              // is always initialized from this mapping; handleSubmit reads back the seeded
              // form value, so the NRI-forced `true` flows through to the submitted payload
              // as long as the form is initialized from this state.
              taxResidentOfAnyCountryOtherThanIndia:
                applicant.taxResidentOfAnyCountryOtherThanIndia ?
                  applicant.taxResidentOfAnyCountryOtherThanIndia : isNRI ?
                    true : false,
              placeOfBirth: applicant.placeOfBirth || '',
              countryOfBirth: applicant.countryOfBirth
                ? applicant.countryOfBirth.toUpperCase()
                : isDiyInvestorOnboarding
                  ? 'INDIA'
                  : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
                    ? ''
                    : 'INDIA',
              countryOfNationality: applicant.countryOfNationality
                ? applicant.countryOfNationality.toUpperCase()
                : isDiyInvestorOnboarding
                  ? 'INDIA'
                  : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
                    ? ''
                    : 'INDIA',
              taxCountryName: applicant?.taxCountryName ? `${applicant.taxCountryName}`.toUpperCase() : '',
              taxID: applicant.taxID || '',
              idType: applicant.idType || '',
              nameOfEntity: applicant.nameOfEntity || '',
              dateOfIncorporation: applicant.dateOfIncorporation || '',
              cityOfIncorporation: applicant.cityOfIncorporation || '',
              countryOfIncorporation: applicant.countryOfIncorporation || '',
              entityExcemptionCode: applicant.entityExcemptionCode || '',
              applicantStatus: applicant.applicantStatus
            }
          }),
          countryDropdown: (nationalitiesList?.countries ?? []).map((list) => list.name),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleSubmit = async (values: Values) => {
    try {
      const {
        applicants: existingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { applicants, saveType } = values;
      const updatedPayload = existingApplicants.map((applicant, index: number) => {
        const {
          taxResidentOfAnyCountryOtherThanIndia = false,
          // dateOfBirth = '',
          dateOfIncorporation = '',
          ...rest
        } = applicants[index];
        return {
          ...applicant,
          // The submitted value is derived from the Formik form value, which was seeded in
          // the state-init mapping above (where the NRI rule forces `true` for NRI applicants
          // and the radio is disabled). Because the form is always initialized from that
          // mapping, the NRI-forced value is preserved here. If the form is reset or an
          // applicant's applicantStatus changes after init without re-seeding from that
          // mapping, the NRI rule would not be re-applied at this point.
          taxResidentOfAnyCountryOtherThanIndia:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' ? false : true,
          // dateOfBirth: dateOfBirth ? dateOfBirth : null,
          dateOfIncorporation: dateOfIncorporation ? dateOfIncorporation : null,
          ...rest,
          placeOfBirth: removeSingleQuote(rest.placeOfBirth),
          taxCountryName:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(rest.taxCountryName),
          taxID:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(rest.taxID),
          idType:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(rest.idType),
        };
      });
      const checkApplication = applicationComparison(application, {
        ...application,
        applicants: updatedPayload,
        currentStep: !!currentStep && currentStep > 6 ? currentStep : Number(currentStep) + 1,
      });
      const isSaveLater = saveType !== 'save and proceed';

      let currentStatus = status

      if (
        !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
        status === 'sent_to_amc_approver'
      ) {
        currentStatus = 'draft'
      } else if (
        !hasPOA &&
        AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
        status !== 'draft' &&
        applyRoleBasedStatus(role)
      ) {
        currentStatus = 'sent_to_amc_approver'
      }

      if (id && !checkApplication) {
        setLoading(true);
        const response = await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedPayload,
              status: currentStatus,
              currentStep: 7,
              //!!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        if (!response) return;
        !isSaveLater
          ? history.push('bank-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('bank-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={fatcaDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, FATCAValidationSchema, true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          columnSpacing={3}
          rowSpacing={1}

          // sx={{
          //   width: '100%',
          //   ml: 0,
          //   '.MuiGrid-item': { px: { xs: 0, sm: '0px' } },
          // }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>

          <Grid item xs={12}>
            <Notes
              displayContent={'FATCA Information is mandatory to disclose any Foreign Citizenship'}
            />
          </Grid>



          {values.applicants.map((applicant, index) => (
            <React.Fragment key={index}>
              {/* <Grid item xs={12} /> */}
              <FatcaDetails
                applicantName={getApplicantName(index + 1)}
                index={index}
                key={index}
                values={applicant}
                nationalitiesMdmsResponse={mdmsCountriesList}
                fatcaIdTypeList={fatcaIdTypeList}
              />
            </React.Fragment>
          ))}
          <Grid item xs={12} sx={{ columnGap: 2 }} />

          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',

              });

            }}
            loader={loading}
            clickedButton={values.saveType}
            saveButtonText='Continue'
            showEndIcon={false}
          />

        </Grid>
      )}
    </Formik>
  );
}
